import { toast } from '@/components/ui/toast';

import { ProgressToastContent } from './ProgressToastContent';

type ProgressToastOptions = {
  title: string;
  label?: string;
  errorTitle?: string;
  onCancel?: () => void;
};

export function createProgressToast({
  title,
  label = 'Processing',
  errorTitle = 'Request failed',
  onCancel,
}: ProgressToastOptions) {
  let cancelling = false;
  const id = toast.add({
    data: { variant: 'loading' },
    title,
    description: <ProgressToastContent progress={0} label={label} />,
    timeout: 0,
    actionProps: onCancel
      ? {
          children: 'Cancel',
          onClick() {
            if (cancelling) {
              return;
            }
            cancelling = true;
            toast.update(id, {
              title: 'Cancelling request',
              actionProps: { children: 'Cancel', disabled: true },
              timeout: 0,
            });
            onCancel();
          },
        }
      : undefined,
  });

  return {
    report(progress: number) {
      if (cancelling) {
        return;
      }
      toast.update(id, {
        description: <ProgressToastContent progress={progress} label={label} />,
        timeout: 0,
      });
    },
    close() {
      toast.close(id);
    },
    error(message: string) {
      toast.update(id, {
        data: { variant: 'error' },
        title: errorTitle,
        description: message,
        actionProps: undefined,
        timeout: 5000,
      });
    },
    cancelled() {
      toast.update(id, {
        data: { variant: 'info' },
        title: 'Request cancelled',
        description: 'The operation was cancelled.',
        actionProps: undefined,
        timeout: 3000,
      });
    },
  };
}
